module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('i', [_c('span', [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_c('span', [_vm._v("1 "), _c('i', [_vm._v("The Dream Book")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002"
    }
  }, [_c('span', [_vm._v("2 "), _c('i', [_vm._v("A Big Explosion")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("3 "), _c('i', [_vm._v("The Celebration")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("4 “"), _c('i', [_vm._v("This Is Your Thief")]), _vm._v("!”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("5 "), _c('i', [_vm._v("Some Kind of Hero")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("6 "), _c('i', [_vm._v("Terrible News")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("7 "), _c('i', [_vm._v("The Brown Suitcase")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("8 "), _c('i', [_vm._v("Bill’s Bombshell")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("9 "), _c('i', [_vm._v("Linda’s Party")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("10 "), _c('i', [_vm._v("Giggles and Buried Treasure")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("11 "), _c('i', [_vm._v("The Secret Window")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("12 "), _c('i', [_vm._v("Bad News from Gracie")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("13 "), _c('i', [_vm._v("A Long, Long Day")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("14 "), _c('i', [_vm._v("Trouble at the Picnic")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("15 “"), _c('i', [_vm._v("What’s Your Secret")]), _vm._v("?”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0